import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService }    from '@ngx-translate/core';

@Pipe({
  name: 'companyIntegration',
})
export class CompanyIntegrationPipe implements PipeTransform {

  constructor(
    private translateService : TranslateService
  ) {}

  transform( value : string ) {
    switch (value) {
      case 'xero':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.XERO.XERO');
      case 'myob':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.MYOB.MYOB');
      case 'qbo':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.QUICKBOOKS.QUICKBOOKS_ONLINE');
    }
  }
}
